import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useEditClientMutation, useGetLibrariesQuery } from '../../../generated/graphql';
import { FormAutoComplete } from '../../form';
import styles from './EditClientDialog.module.css';

type EditClientDialogProps = {
    onClose: () => void,
    id: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const EditClientDialog = (props: EditClientDialogProps) => {
    const { id, style, visible, onClose } = props;
    const [editClient, editClientResult] = useEditClientMutation();
    const [searchText, setSearchText] = useState('');
    const [validationError, setValidationError] = useState('');

    const libraryData = useGetLibrariesQuery({
        variables: { clientId: id, contains: searchText }
    });

    const handleSubmit = () => {
        const selected = libraryData.data?.LibraryList?.nodes?.filter(l => l?.name === searchText)[0];
        if (!searchText) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!selected) {
            setValidationError('Please Select A Valid Library!');
            return;
        }
        setValidationError('');
        editClient({
            variables: { id, libraryId: selected?.id }
        })
            .then(() => { onClose(); })
            .catch(() => {});
    };

    return (
        <DialogBase
            title="Edit Client"
            type="OkCancel"
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.EditClientDialog}
            style={style}
            data-testid="EditClientDialog"
            isLoading={editClientResult.loading}>
            <FormAutoComplete
                label="Default Library"
                name="library"
                value={searchText}
                onChange={setSearchText}
                options={(libraryData.data?.LibraryList?.nodes?.map(l => l?.name) || []).filter((n): n is string => !!n)}
            />
        </DialogBase>
    );
};

export default EditClientDialog;